// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { Credential } from '@daml.js/utility-credential-v0/lib/Utility/Credential/V0/Credential';
import { ProviderConfiguration } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Configuration/Provider';
import { HolderServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Holder';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';

const useAcceptHolderServiceRequest: () => UseMutationResult<
  void,
  string,
  {
    holderServiceRequestCid: ContractId<HolderServiceRequest>;
    providerConfigurationCid: ContractId<ProviderConfiguration>;
    credentialCids: ContractId<Credential>[];
  }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();

  return useMutation({
    mutationKey: ['acceptRegistryHolderServiceRequest', ledgerApi, operator],
    mutationFn: async ({ holderServiceRequestCid, providerConfigurationCid, credentialCids }) => {
      return ledgerApi.acceptRegistryHolderServiceRequest(
        holderServiceRequestCid,
        providerConfigurationCid,
        credentialCids,
      );
    },
  });
};

export default useAcceptHolderServiceRequest;
